import { Injectable } from '@angular/core';
import {
  ICreateEmailTemplatePayload,
  ICreateSMSTemplatePayload,
  ITemplateDTO,
  ITemplateDataResponse,
  ITemplatePayload,
  ITemplateVariable,
} from '@g99-product-web-ui/shared-interface-lib';
import {
  API_ENDPOINTS,
  SERVICE_PREFIX,
} from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService {
  constructor(private readonly _httpService: HttpService) {}

  //for get template
  public getTemplatedById(
    type: string,
    id: number | null
  ): Observable<ITemplatePayload> {
    return this._httpService.get(
      `/${SERVICE_PREFIX.PRODUCT_SVC_EXT}/${type}templates/${id}`
    );
  }

  //for fetching variables details
  public getVariableDetails() {
    const apiUrl = `${API_ENDPOINTS.TEMPLATE_ENDPOINTS.getVariableDetails}`;
    return this._httpService.get<ITemplateVariable>(apiUrl);
  }

  //for fetching  template variable details
  public getTemplateVariable(type: string, smsTemplateName: string) {
    const apiUrl = `${API_ENDPOINTS.TEMPLATE_ENDPOINTS.getTemplateVariable(type, smsTemplateName)}`;
    return this._httpService.get<ITemplateVariable[]>(apiUrl);
  }

  /**
   * Updates an existing template with the specified payload.
   *
   * @param template - The type of template to update (e.g., "email").
   * @param id - The unique identifier of the template.
   * @param payload - The data to update in the template.
   * @returns An observable containing the response of the update request.
   */
  public updateTemplate(
    template: string,
    id: number,
    payload: ITemplatePayload
  ): Observable<ITemplatePayload> {
    return this._httpService.put(
      `/${SERVICE_PREFIX.PRODUCT_SVC_EXT}/${template}/${id}`,
      payload
    );
  }

  // Get list of template for mail, SMS
  public getTemplateList(): Observable<ITemplateDataResponse> {
    const apiUrl = API_ENDPOINTS.TRIGGER_ENDPOINTS.v1TriggerEdit;
    return this._httpService.get<ITemplateDataResponse>(apiUrl);
  }

  public createSMSTemplate(
    template: string,
    payload: ICreateSMSTemplatePayload
  ): Observable<ITemplateDTO> {
    return this._httpService.post(
      `${SERVICE_PREFIX.PRODUCT_SVC_EXT}/${template}`,
      payload
    );
  }

  /**
   * Sends a request to create a new email template.
   *
   * @param template - The endpoint or template identifier (e.g., 'createEmailTemplate', 'email/template').
   * @param payload - The payload containing the details of the email template to be created.
   * @returns An `Observable` emitting the created email template data including resolved variables.
   */
  public createEmailTemplate(
    template: string,
    payload: ICreateEmailTemplatePayload
  ): Observable<ITemplateDTO> {
    return this._httpService.post(
      `${SERVICE_PREFIX.PRODUCT_SVC_EXT}/${template}`,
      payload
    );
  }
}
